(function () {
  function initHdabReveal(root) {
    if (!root || root.dataset.hdabRevealInit) return;
    root.dataset.hdabRevealInit = "1";
    var nodes = root.querySelectorAll("[data-reveal]");
    if (!nodes.length) return;
    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );
    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  function getVisibleWhyVideo(wrap) {
    var videos = wrap.querySelectorAll("video");
    var visible = null;
    videos.forEach(function (video) {
      if (window.getComputedStyle(video).display !== "none") {
        visible = video;
      }
    });
    return visible || videos[0] || null;
  }

  function setWhyPlaying(wrap, playing) {
    wrap.classList.toggle("is-playing", playing);
    var btn = wrap.querySelector(".why-media__play");
    if (btn) {
      btn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
    }
  }

  function pauseWhyVideos(wrap, except) {
    wrap.querySelectorAll("video").forEach(function (video) {
      if (except && video === except) return;
      video.pause();
    });
  }

  function initWhyMediaVideo(wrap) {
    if (!wrap || wrap.dataset.hdabWhyVideoInit) return;
    wrap.dataset.hdabWhyVideoInit = "1";

    var btn = wrap.querySelector(".why-media__play");
    if (!btn) return;

    wrap.querySelectorAll("video").forEach(function (video) {
      video.removeAttribute("autoplay");
      video.controls = false;
      video.muted = false;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");

      video.addEventListener("play", function () {
        setWhyPlaying(wrap, true);
      });
      video.addEventListener("pause", function () {
        if (getVisibleWhyVideo(wrap) === video) {
          setWhyPlaying(wrap, false);
        }
      });
      video.addEventListener("ended", function () {
        setWhyPlaying(wrap, false);
        video.currentTime = 0;
      });
      video.addEventListener("click", function () {
        if (!video.paused) {
          video.pause();
        }
      });
    });

    function togglePlayback() {
      var video = getVisibleWhyVideo(wrap);
      if (!video) return;

      pauseWhyVideos(wrap, video);
      video.muted = false;
      video.removeAttribute("muted");

      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === "function") {
          playPromise
            .then(function () {
              setWhyPlaying(wrap, true);
            })
            .catch(function () {
              setWhyPlaying(wrap, false);
            });
        } else {
          setWhyPlaying(wrap, true);
        }
      } else {
        video.pause();
        setWhyPlaying(wrap, false);
      }
    }

    btn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      togglePlayback();
    });
  }

  function initHdab(root) {
    if (!root) return;
    initHdabReveal(root);
    root.querySelectorAll("[data-why-video], .why-media--video").forEach(initWhyMediaVideo);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".hdab").forEach(initHdab);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector(".hdab");
    if (root) {
      root.dataset.hdabRevealInit = "";
      root.querySelectorAll("[data-why-video], .why-media--video").forEach(function (wrap) {
        wrap.dataset.hdabWhyVideoInit = "";
      });
      initHdab(root);
    }
  });
})();
